// Import controls
import api from './api.vue';

export default function registerComponents(app) {

    // Control registration
    app.component('f-api', api);

}